import React, { useEffect, useState } from "react";
import "../../css/Footer.css";
import LazyLinePainter from "lazy-line-painter";
import CorporatePlan from "../Landing/CorporatePlan";
import { Card, Modal, Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { NavLink } from "reactstrap";
import NatalForm from "../Landing/NatalForm";

class Footer extends React.Component {
  state = {
    show: false,
    view: false,
  };

  componentDidMount() {
    let els = {
      logo: document.querySelector("#lion"),
    };
    let myAnimation;
    myAnimation = new LazyLinePainter(els.logo, {
      strokeWidth: 2.4,
      strokeCap: "round",
      strokeColor: "#a9d372",
      ease: "easeInOutSine",
      drawSequential: true,
      repeat: -1,
      delay: 500,
    });
    myAnimation.paint();
  }

  changeshow() {
    this.setState({
      show: false,
    });
  }

  changeview() {
    this.setState({
      view: false,
    });
  }

  callcorporate() {
    this.setState({
      show: true,
    });
  }

  callnatal() {
    this.setState({
      view: true,
    });
  }

  render() {
    return (
      <>
        <div className="How-it-works">
          <h2 className="header-three">How it works</h2>
          
          {/* Desktop Image */}
          <img
            className="our-customer-img d-none d-md-block"
            src={require("./../../assests/howitworks.png")}
            alt="How it works"
          />
          
          {/* Mobile Carousel */}
          <div className="d-block d-md-none">
            <HowItWorksCarousel />
          </div>
        </div>
        
        {/* Mobile Heading */}
        <h2 className="header-three d-block d-md-none">Our Customers <br/> love what we do</h2>
        
        {/* Desktop Heading */}
        <img
          className="our-customer-img d-none d-md-block"
          src={require("./../../assests/reviews/our_cust.svg")}
          style={{
            width: "30%",
            height: "auto",
            alignSelf: "center",
            marginBottom: "4rem",
            marginTop: "2rem",
          }}
          alt={`Our Customer`}
        />
        
        <div className="our-customer">
          <CarouselReview />
        </div>
        
        <section className="foot">
          <div className="container-fluid">
            <div className="row container-row align-items-start">
              <div className="media-space footer-img col-sm-12 col-lg-6 col-xl-3 text-center">
                <a href="/">
                  <img src={require("../../assests/fitlogo.png")} />
                </a>
                <div className="mt-4 text-left">
                  Our Mission <br></br>
                  At Fitfinity Trainer our mission is to empower individuals to
                  live healthier more balanced lives by bringing expert personal
                  training yoga and customized diet planning directly into the
                  comfort of your home We believe that fitness isn't one size
                  fits all so we deliver personalized guidance that adapts to
                  your lifestyle goals and aspirations Your journey becomes our
                  commitment to nurture strength vitality and confidence at
                  every step
                </div>
              </div>

              <div className=" media-space col-sm-12 col-lg-6 col-xl-2">
                <h4 className="text-color">
                  <strong>Services</strong>
                </h4>
                <ul className="itemsfoot ">
                  <a onClick={() => this.props.history.push("/booksession")}>
                    <li
                      style={{
                        fontSize: "14px",
                        textTransform: "uppercase",
                        fontFamily: "Roboto",
                      }}
                    >
                      Weighloss & Toning
                    </li>
                  </a>{" "}
                  <a onClick={() => this.props.history.push("/booksession")}>
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Cardio fitness
                    </li>
                  </a>
                  <a
                    onClick={() => {
                      this.callnatal();
                    }}
                  >
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Pre/Post Natal exercise
                    </li>
                  </a>
                  <a
                    onClick={() => {
                      this.callcorporate();
                    }}
                  >
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Weight/resistance training
                    </li>
                  </a>
                  <a
                    onClick={() => {
                      this.callcorporate();
                    }}
                  >
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Corporate Fitness
                    </li>
                  </a>
                  <a onClick={() => this.props.history.push("/booksession")}>
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Youth and team fitness
                    </li>
                  </a>
                  <a onClick={() => this.props.history.push("/booksession")}>
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Yoga Training
                    </li>
                  </a>
                  <a onClick={() => this.props.history.push("/booksession")}>
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Group training
                    </li>
                  </a>
                  <a onClick={() => this.props.history.push("/institute")}>
                    <li
                      style={{ fontSize: "14px", textTransform: "uppercase" }}
                    >
                      Sports Conditioning
                    </li>
                  </a>
                </ul>
              </div>
              <div className="media-space col-sm-12 col-lg-6 col-xl-2">
                <h4 className="text-color">
                  <strong>How it Works</strong>
                </h4>
                <ul className="itemsfoot faq_item_mq">
                  <a
                    href="mailto:fitfinitytrainer@gmail.com?subject=Please submit your CV"
                    onClick={() => this.props.history.push("/privacy")}
                  >
                    <li
                      style={{ color: "#D0A26E", textTransform: "uppercase" }}
                    >
                      careers
                    </li>
                  </a>
                  <a
                    onClick={() => this.props.history.push("/Refund")}
                    href="mailto:fitfinitytrainer@gmail.com"
                  >
                    <li
                      style={{ color: "#D0A26E", textTransform: "uppercase" }}
                    >
                      Contact us
                    </li>
                  </a>
                </ul>
              </div>
              <div className="media-space col-sm-12 col-lg-6 col-xl-2">
                <h4 className="text-color">
                  <strong>FAQ</strong>
                </h4>
                <ul className="itemsfoot faq_item_mq">
                  <a onClick={() => this.props.history.push("/privacy") }>
                    <li
                      style={{ color: "#D0A26E", textTransform: "uppercase" }}
                    >
                      about us
                    </li>
                  </a>
                  <a
                    onClick={() => this.props.history.push("/TermsConditions")}
                  >
                    <li
                      style={{ color: "#D0A26E", textTransform: "uppercase" }}
                    >
                      Terms <span style={{ fontFamily: "Roboto" }}>&</span>{" "}
                      Conditions
                    </li>
                  </a>
                  <a onClick={() => this.props.history.push("/Refund")}>
                    <li
                      style={{ color: "#D0A26E", textTransform: "uppercase" }}
                    >
                      Refund Policy
                    </li>
                  </a>
                </ul>
              </div>
              <div
                className="media-space col-sm-12 col-lg-6 col-xl-3
             "
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div>
                    <img
                      src={require("./../../assests/app_store.png")}
                      onClick={() => {
                        alert(
                          "We're live on Google Play! The App Store version is on its way — stay tuned"
                        );
                      }}
                    />
                    <a href="https://play.google.com/store/apps/details?id=com.fitfinity.user&pcampaignid=web_share">
                      <img
                        className="mt-4"
                        src={require("./../../assests/google-play.png")}
                      />
                    </a>
                  </div>
                  <img
                    className="ml-4 "
                    src={require("./../../assests/proudly.png")}
                    alt="asset1"
                    style={{width:"161px"}}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 79.46 79.51"
                    data-llp-composed="true"
                    id="lion"
                    className="lazy-line-painter"
                  ></svg>
                </div>
              </div>

              <Modal show={this.state.show} onHide={() => this.changeshow()}>
                <Modal.Header closeButton></Modal.Header>
                <CorporatePlan onHide={() => this.changeshow()} />
              </Modal>

              <Modal
                show={this.state.view}
                onHide={() => this.changeview()}
                className="col-sm-12"
              >
                <Modal.Header closeButton></Modal.Header>
                <NatalForm onHide={() => this.changeview()} />
              </Modal>
            </div>
          </div>
        </section>
      </>
    );
  }
}
export default withRouter(Footer);

const reviewImages = [
  require("./../../assests/reviews/1.svg"),
  require("./../../assests/reviews/2.svg"),
  require("./../../assests/reviews/3.svg"),
  require("./../../assests/reviews/4.svg"),
  require("./../../assests/reviews/5.svg"),
  require("./../../assests/reviews/6.svg"),
  require("./../../assests/reviews/7.svg"),
];

// How It Works Carousel Component for Mobile
const howItWorksImages = [
  require("./../../assests/howitwork1.jpg"),
  require("./../../assests/howitwork3.jpg"),
  require("./../../assests/howitwork2.jpg"),
  require("./../../assests/howitwork4.jpg"),


];

function HowItWorksCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % howItWorksImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);


  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        position: "relative",
        padding: "0 16px",
      }}
    >
      {/* Left Arrow */}


      <img
        style={{
          width: "100%",
          maxWidth: "280px",
          height: "auto",
          alignSelf: "center",
          borderRadius: "8px",
        }}
        src={howItWorksImages[index]}
        alt={`How it works step ${index + 1}`}
      />

 

      {/* Square Dots Indicator */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "6px",
          position: "absolute",
          bottom: "-30px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
        }}
      >
        {howItWorksImages.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            style={{
              width: i === index ? "10px" : "6px",
              height: i === index ? "10px" : "6px",
              backgroundColor: i === index ? "#D0A26E" : "#ccc",
              borderRadius: "1px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              marginBottom:"20px"
            }}
          />
        ))}
      </div>
    </div>
  );
}

function CarouselReview() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviewImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const goPrev = () => {
    setIndex((prev) => (prev - 1 + reviewImages.length) % reviewImages.length);
  };

  const goNext = () => {
    setIndex((prev) => (prev + 1) % reviewImages.length);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
        position: "relative",
      }}
    >
      {/* Left Arrow - Hidden on Mobile */}
      <button
        onClick={goPrev}
        className="d-none d-md-block"
        style={{
          marginRight: 16,
          fontSize: 25,
          background: "black",
          border: "3px solid #D0A26E",
          borderRadius: "50%",
          width: 48,
          height: 48,
          color: "#D0A26E",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
        aria-label="Previous Review"
      >
        &#8592;
      </button>

      <img
        className="our-customer-img"
        style={{
          width: "100%",
          maxWidth: "800px",
          height: "auto",
          alignSelf: "center",
        }}
        src={reviewImages[index]}
        alt={`review-${index + 1}`}
      />

      {/* Right Arrow - Hidden on Mobile */}
      <button
        onClick={goNext}
        className="d-none d-md-block"
        style={{
          marginLeft: 16,
          fontSize: 25,
          background: "black",
          border: "3px solid #D0A26E",
          borderRadius: "50%",
          width: 48,
          height: 48,
          color: "#D0A26E",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
        aria-label="Next Review"
      >
        &#8594;
      </button>

      {/* Square Dots Indicator */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          position: "absolute",
          bottom: "-40px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
        }}
      >
        {reviewImages.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            style={{
              width: i === index ? "12px" : "8px",
              height: i === index ? "12px" : "8px",
              backgroundColor: i === index ? "#D0A26E" : "#ccc",
              borderRadius: "2px",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </div>
    </div>
  );
}